var PlatformTypes;
(function (PlatformTypes) {
    PlatformTypes["ADOBE_AIR"] = "adobe-air";
    PlatformTypes["ANDROID"] = "android";
    PlatformTypes["CORDOVA"] = "cordova";
    PlatformTypes["DEFOLD"] = "defold";
    PlatformTypes["DESKTOP"] = "desktop";
    PlatformTypes["FIREOS"] = "fireos";
    PlatformTypes["FLUTTER"] = "flutter";
    PlatformTypes["GODOT"] = "godot";
    PlatformTypes["IOS"] = "ios";
    PlatformTypes["REACT_NATIVE"] = "react-native";
    PlatformTypes["UNITY"] = "unity";
    PlatformTypes["UNREAL"] = "unreal";
    PlatformTypes["OTHER"] = "other";
})(PlatformTypes || (PlatformTypes = {}));
export default PlatformTypes;
//# sourceMappingURL=PlatformTypes.js.map